import { render, staticRenderFns } from "./MoviePoster.vue?vue&type=template&id=7447f5a0&lang=pug&"
import script from "./MoviePoster.vue?vue&type=script&lang=js&"
export * from "./MoviePoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoviePoster.vue"
export default component.exports